// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3TrsI","image":"App_image__38sbP","footer":"App_footer__2rvNY"};